/* eslint-disable react/prop-types */
import React, { useEffect, useState, useContext } from 'react';
import { mdiCheckboxMarkedCircleOutline } from '@mdi/js';
import { format } from 'date-fns';
import { Document, Page, pdfjs } from 'react-pdf';
import api from '~/services/api';
import { ModalPharmacist, AlertMessage } from '~/shared/components';
import { MainContext } from '~/context';
import { MedicationInformationForm, CardRecipe } from './components';

import {
  Container,
  TitleAcess,
  ButtonRecipe,
  ButtonContainer,
  PdfContainer,
  ButtonClose,
  ButtonBox,
  DocumentsDownload,
  DownloadButton,
  VerificaButtonOld,
} from './styles';
import DownloadInMemoryLink from '~/shared/components/downloadButton';
import validateHashOrigin from '~/utils';
import { getDocumentAuthorizationToken } from '~/utils/documentAuthorization';

const PrescriptionDataView = ({ tokenRef = null }) => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  const [showingData, setShowingData] = useState('');
  const [pdfOpen, setpdfOpen] = useState(false);
  const [pdfModalTitle, setPdfModalTitle] = useState('');
  const [pdfItems, setpdfItems] = useState('');
  const [pdfItemShowing, setpdfItemShowing] = useState('');
  const [numPages, setNumPages] = useState(null);
  const [isControlled, setIsControlled] = useState(false);
  const [messageAlert, setmessageAlert] = useState('Validação concluída');
  const [medicationInformationModal, setMedicationInformationModal] =
    useState(false);

  const context = useContext(MainContext);
  const { buttonDisplay, setButtonDisplay, dataDocument, alertControlled } =
    context;

  useEffect(() => {
    const document = dataDocument;
    if (document) {
      const doctorArticle = 'Dr(a).';
      const showInfo = {
        patientName: document.patient?.name ?? null,
        date: document.datetime
          ? format(new Date(document.datetime), 'dd/MM/yyyy')
          : null,
        doctorArticle,
        doctorName: document.doctor?.name ?? null,
      };
      setShowingData(showInfo);

      setIsControlled(
        document.data.some((prescriptionItem) => prescriptionItem.controlled)
      );
    }
  }, [dataDocument, setButtonDisplay, buttonDisplay]);

  useEffect(() => {
    if (alertControlled) {
      setmessageAlert('Não há receituário controlado para este atendimento.');
    }
  }, [alertControlled, messageAlert]);

  const handleOpenPdf = () => {
    setPdfModalTitle('Documentos emitidos');
    if (dataDocument?.oldVerifica) {
      setpdfItemShowing(dataDocument.data[0].url);
      setpdfItems(dataDocument.data);
      setpdfOpen(true);
    } else {
      const accessToken = getDocumentAuthorizationToken();
      let classificationId = dataDocument.data[0].classification_id;
      const filterMedication = dataDocument.data.filter(
        (medication) => medication.classification_id === 3
      );

      if (filterMedication.length > 0) {
        classificationId = 3;
      }
      api
        .get(
          `/document/file/${validateHashOrigin(tokenRef)}/${classificationId}`,
          {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
            },
          }
        )
        .then(({ data: responseData }) => {
          setpdfItemShowing(responseData[0].url);
          setpdfItems(responseData);
          setpdfOpen(true);
        });
    }
  };

  const onDocumentLoadSuccess = ({ numPages: loadedPages }) => {
    setNumPages(loadedPages);
  };
  const RenderButton = () => {
    const doc = dataDocument.data[0];
    return (
      <a href={doc.url} target="_blank" rel="noreferrer">
        <DocumentsDownload
          width="216px"
          textColor="#2196f3"
          backgroundColor="#F9F9FB"
          borderColor="#2493EB"
        >
          {'Baixar '}
          {doc.name || ' Documento'}
        </DocumentsDownload>
      </a>
    );
  };

  const toggleModal = () => setMedicationInformationModal((state) => !state);

  return (
    <Container>
      <AlertMessage
        alert
        icon={mdiCheckboxMarkedCircleOutline}
        message={messageAlert}
        background={alertControlled}
      />
      <TitleAcess>
        Documento emitido com certificação digital padrão ICP Brasil
      </TitleAcess>
      <CardRecipe
        isControlled={isControlled}
        showingData={showingData}
        tokenRef={tokenRef}
      />
      <ButtonContainer>
        {!alertControlled && !dataDocument?.oldVerifica && (
          <ButtonRecipe
            type="button"
            width="216px"
            textColor="#2196f3"
            backgroundColor="#F9F9FB"
            borderColor="#2493EB"
            onClick={handleOpenPdf}
          >
            ver documento em pdf
          </ButtonRecipe>
        )}
        {dataDocument?.oldVerifica && dataDocument.data ? (
          <VerificaButtonOld>{RenderButton()}</VerificaButtonOld>
        ) : null}
      </ButtonContainer>
      {pdfOpen && (
        <ModalPharmacist
          isOpen={pdfOpen}
          widthContainer="910px"
          heightContainer="640px"
          title={pdfModalTitle}
          onCloseRequest={(event) => {
            event.preventDefault();
            setpdfOpen(false);
          }}
          itens={pdfItems}
          onClickItens={(item) => {
            setpdfItemShowing(item.url);
          }}
        >
          <PdfContainer>
            <Document
              file={pdfItemShowing}
              onLoadSuccess={onDocumentLoadSuccess}
              loading=""
              height="auto"
              width="100vw"
              renderMode="canvas"
            >
              {[1, 2].map((page) => (
                <Page
                  key={`page_${page + 1}`}
                  pageNumber={page >= 0 ? page : 0}
                />
              ))}
            </Document>
          </PdfContainer>
          <ButtonBox>
            <DownloadButton>
              <DownloadInMemoryLink url={pdfItemShowing}>
                Fazer o download
              </DownloadInMemoryLink>
            </DownloadButton>
            <ButtonClose
              onClick={() => {
                setpdfOpen(!pdfOpen);
              }}
            >
              Fechar
            </ButtonClose>
          </ButtonBox>
        </ModalPharmacist>
      )}
      <ModalPharmacist
        isOpen={medicationInformationModal}
        title="Informação de medicamento"
        widthContainer="60%"
        onCloseRequest={toggleModal}
      >
        <MedicationInformationForm
          onClose={toggleModal}
          handleChange={() => {}}
          handleSubmit={() => {}}
          touched={() => {}}
          errors={() => {}}
          values={{}}
        />
      </ModalPharmacist>
    </Container>
  );
};

export default PrescriptionDataView;
